import {
  ChangeDetectionStrategy,
  Component,
  input,
  Input,
} from '@angular/core';
import { PlayerContentItem } from '@splixer/player';

@Component({
  selector: 'pv2-track-banner',
  templateUrl: 'track-banner.component.html',
  styleUrl: '../player-v2-styles.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [],
})
export class Pv2TrackBannerComponent {
  public readonly content = input<PlayerContentItem | undefined>();
}
